<tui-icon
  *ngIf="appearance === 'icon'; else tmpBlock"
  [icon]="isFavorite ? '@tui.heart-filled' : '@tui.heart'"
  [style.color]="isFavorite ? 'var(--unions-color-pink)' : 'var(--unions-color-icon)'"
  [style.font-size.px]="24"
  (click)="switchFavorite($event)"
></tui-icon>

<ng-template #tmpBlock>
  <button
    tuiIconButton
    type="button"
    [iconStart]="isFavorite ? '@tui.heart-filled' : '@tui.heart'"
    [appearance]="dataAppearance"
    [size]="size"
    [tuiHint]="
      isDesktop
        ? ((isFavorite
            ? 'components.favoriteButton.labels.removeFavoriteHint'
            : 'components.favoriteButton.labels.addFavoriteHint'
          ) | translate)
        : ''
    "
    (click)="switchFavorite($event)"
  ></button>
</ng-template>
